import i18n from 'i18next'

import { OptimizationProcessStatus } from '../types'
import {
  ABORTED,
  CREATED,
  DONE,
  FAILED,
  RUNNING,
  STOPPING,
} from '../types/optimizationProcesses'

export const getOptimizationProcessStatus = (
  status: OptimizationProcessStatus
): string => {
  const name = {
    [RUNNING]: i18n.t('Running'),
    [DONE]: i18n.t('Completed'),
    [CREATED]: i18n.t('Queued'),
    [FAILED]: i18n.t('Failed'),
    [STOPPING]: i18n.t('Stopping'),
    [ABORTED]: i18n.t('Aborted'),
  }

  return name[status]
}
